import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { adminProfileUpdate, getUser } from '../../../api/redux/slices/Auth';
import './index.scss';
import { toast } from 'react-toastify';
import { ButtonComponent } from '../../../components/buttons';

const EditProfile = ({ infos, resetPage }) => {
	const dispatch = useDispatch();
	const token = localStorage.getItem('accesstoken');

	const [isLoading, setisLoading] = useState(false);

	const [values, setValues] = useState({
		first_name: infos.first_name,
		last_name: infos.last_name,
		phone: infos.phone,
		email: infos.email,
	});

	const handleUpdate = (e) => {
		e.preventDefault();
		const data = {
			first_name: values.first_name,
			last_name: values.last_name,
			phone: values.phone,
			email: values.email,
		};

		setisLoading(true);
		
		// D'abord, mettre à jour le profil
		dispatch(adminProfileUpdate({ token: token, data: data }))
			.unwrap()
			.then(() => {
				// Ensuite, recharger les données utilisateur
				return dispatch(getUser({ token: token })).unwrap();
			})
			.then(() => {
				toast.success('Profil mis à jour avec succès');
				resetPage();
			})
			.catch((err) => {
				toast.warn(err?.message || 'Erreur lors de la mise à jour', {
					position: 'top-center',
					autoClose: 2000,
				});
			})
			.finally(() => setisLoading(false));
	};
	
	const handleCancel = (e) => {
		e.preventDefault();
		resetPage();
	};

	return (
		<div className='edit-profile-container'>
			<div className='navbar'>
				<div className='left'>
					<h1>Modifier le profil</h1>
				</div>
				<div className='right'>
					<div className='edit-profile-button'>
						<button
							className='button-nature'
							onClick={handleCancel}
						>
							Annuler
						</button>
						<ButtonComponent
							className='button-primary'
							loading={isLoading}
							type='submit'
							name={'Enregistrer'}
							onClick={handleUpdate}
						/>
					</div>
				</div>
			</div>

			<form onSubmit={handleUpdate} className='edit-profile-form'>
				<div className='form-fields'>
					<div className='label-input'>
						<label>Nom</label>
						<input
							type='text'
							placeholder='Foulen'
							value={values.first_name}
							onChange={(e) => {
								setValues({ ...values, first_name: e.target.value });
							}}
						/>
					</div>
					<div className='label-input'>
						<label>Prénom</label>
						<input
							type='text'
							placeholder='Ben foulen'
							value={values.last_name}
							onChange={(e) => {
								setValues({ ...values, last_name: e.target.value });
							}}
						/>
					</div>
					<div className='label-input'>
						<label>Adresse e-mail</label>
						<input
							type='email'
							placeholder='foulen.benfoulen@email.com'
							value={values.email}
							onChange={(e) => {
								setValues({ ...values, email: e.target.value });
							}}
						/>
					</div>
					<div className='label-input'>
						<label>Numéro de téléphone</label>
						<input
							type='text'
							placeholder='21 212 212'
							value={values.phone}
							onChange={(e) => {
								setValues({ ...values, phone: e.target.value });
							}}
						/>
					</div>
				</div>
			</form>
		</div>
	);
};

export default EditProfile;